import { useCallback, useSyncExternalStore } from 'react';

/**
 * O mesmo roteador mínimo do painel (painel/src/rota.ts), com outra BASE.
 * URL de verdade pelo mesmo motivo de lá: o botão "voltar" do Android tem
 * que sair do detalhe do prêmio, não fechar o app. O Express serve o
 * index.html para qualquer caminho sob /app.
 */

/*
 * A base é DESCOBERTA, não cravada: em cerchia.../app ela é '/app', mas no
 * domínio próprio (app.cerchia.com.br) o app mora na raiz e a base é vazia —
 * o servidor reescreve o caminho por dentro, e a barra de endereço fica limpa.
 */
const BASE = window.location.pathname.startsWith('/app') ? '/app' : '';

const ouvintes = new Set<() => void>();

function avisar(): void {
  for (const f of ouvintes) f();
}

function assinar(f: () => void): () => void {
  ouvintes.add(f);
  window.addEventListener('popstate', f);
  return () => {
    ouvintes.delete(f);
    window.removeEventListener('popstate', f);
  };
}

function ler(): string {
  const p = window.location.pathname;
  const dentro = p.startsWith(BASE) ? p.slice(BASE.length) : p;
  return dentro.replace(/\/+$/, '') || '/';
}

export function navegar(para: string, substituir = false): void {
  const alvo = para === '/' ? (BASE ? `${BASE}/` : '/') : BASE + para;
  if (alvo === window.location.pathname) return;
  if (substituir) window.history.replaceState(null, '', alvo);
  else window.history.pushState(null, '', alvo);
  avisar();
}

export function voltar(): void {
  window.history.back();
}

export function useRota(): { caminho: string; ir: (p: string) => void } {
  const caminho = useSyncExternalStore(assinar, ler, () => '/');
  const ir = useCallback((p: string) => navegar(p), []);
  return { caminho, ir };
}

/** Extrai o id de `/<secao>/<id>`; nulo quando a rota não é de detalhe. */
export function idDetalhe(caminho: string, secao: string): string | null {
  const m = new RegExp(`^/${secao}/([^/]+)$`).exec(caminho);
  return m?.[1] ?? null;
}
